export default __webpack_public_path__ + "static/media/qualification.14021c8f.svg";